import React from 'react';
import { View, Text, StyleSheet, Modal, TouchableOpacity, ScrollView, Platform } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { colores, fuentes } from '../../styles/variablesCss';

const ProductosBorradosModal = ({ visible, productosBorrados, onClose }) => {
  if (!productosBorrados || productosBorrados.length === 0) {
    return null;
  }

  return (
    <Modal
      visible={visible}
      transparent={true}
      animationType="fade"
      onRequestClose={onClose}
    >
      <View style={styles.overlay}>
        <View style={styles.modalContainer}>
          <View style={styles.header}>
            <MaterialCommunityIcons name="delete-alert" size={32} color={colores.rojo} />
            <Text style={styles.title}>Productos eliminados</Text>
          </View>

          <Text style={styles.mensaje}>
            Los siguientes productos ya no están disponibles en la sucursal seleccionada y fueron eliminados del carrito:
          </Text>

          <ScrollView style={styles.productosContainer}>
            {productosBorrados.map((producto, index) => (
              <View key={producto.plu || index} style={styles.productoItem}>
                <MaterialCommunityIcons name="close-circle" size={20} color={colores.rojo} />
                <Text style={styles.productoDescripcion}>
                  {producto.descripcion}
                </Text>
              </View>
            ))}
          </ScrollView>

          <View style={styles.botonesContainer}>
            <TouchableOpacity
              style={[styles.boton, styles.botonAceptar]}
              onPress={onClose}
            >
              <Text style={styles.botonTexto}>Entendido</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  modalContainer: {
    backgroundColor: colores.blanco,
    borderRadius: 12,
    padding: 24,
    width: '100%',
    maxWidth: 500,
    maxHeight: '80%',
    ...(Platform.OS === 'web' && {
      boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
    }),
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
    gap: 12,
  },
  title: {
    fontSize: 20,
    fontFamily: fuentes.bold,
    color: colores.textoPrincipal,
    flex: 1,
  },
  mensaje: {
    fontSize: 15,
    fontFamily: fuentes.regular,
    color: colores.textoSecundario,
    marginBottom: 20,
    lineHeight: 22,
  },
  productosContainer: {
    maxHeight: 300,
    marginBottom: 20,
  },
  productoItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 12,
    backgroundColor: '#FFF5F5',
    borderRadius: 8,
    marginBottom: 8,
    borderLeftWidth: 3,
    borderLeftColor: colores.rojo,
    gap: 12,
  },
  productoDescripcion: {
    fontSize: 14,
    fontFamily: fuentes.regular,
    color: colores.textoPrincipal,
    flex: 1,
    textTransform: 'capitalize',
  },
  botonesContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 12,
  },
  boton: {
    flex: 1,
    paddingVertical: 14,
    paddingHorizontal: 16,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  botonAceptar: {
    backgroundColor: colores.rojo,
  },
  botonTexto: {
    fontSize: 14,
    fontFamily: fuentes.semiBold,
    color: colores.blanco,
    textAlign: 'center',
  },
});

export default ProductosBorradosModal;
